__turbopack_context__.v({
  "price": "ProductDetail-module__DDaDbW__price",
  "root": "ProductDetail-module__DDaDbW__root",
});
